import {CreateRuleSetState} from "../../../../components/configs/rulesets/create/CreateRuleSetState";
import { RuleSetModalState } from "../modal/RuleSetModalState";
import { TreeNode } from "../../../../components/configs/rulesets/create/CreateRuleForm";
import {batchTypesConstatns} from "../../../../utils/constants"

export function addRulesToCode(state){
    const rules = state.ruleSetModalState.createRuleSetState.grabRuleSetForCode()
    const formatRules = JSON.parse(rules)
    if(rules?.length > 0 && formatRules.length > 0 && !state.ruleSetModalState.noRuleOpen){
        state.rules = state.ruleSetModalState.noRuleOpen? "[]": rules
        return state.rules
    }else if(state.ruleSetModalState.noRuleOpen || formatRules.length === 0){
        state.rules = "[]"
        state.ruleSetModalState.reset(false)
        if(state.batchType === batchTypesConstatns.EDIT) {
            state.ruleSetModalState.isRemovedRules = true
        } else if(state.batchType === batchTypesConstatns.CREATE){
            state.ruleSetModalState.noRuleOpen = true
        }
        return []
    } else {
        return null
    }
}

export async function initRuleSetModalState(rootStore, nodeUuid, isView){
    const ruleSetSelectState = rootStore.rootUiStore.ruleSetSelectState;
    const ruleTypeSelectState = rootStore.rootUiStore.ruleTypeSelectState;
    ruleSetSelectState?.store?.clearSearchParams() // to reset ruleSets store same problem above for tags
    await ruleSetSelectState?.store?.init({}) // reset ruleSets
    ruleSetSelectState.clearSelection()
    const rootNode = TreeNode.create({
        nodeUuid: nodeUuid,
        parent: null,
        order: 0,
        children: [],
        showIndent: false,
        showUnindent: false,
        position: '0',
        volatileRuleTypeStore: ruleTypeSelectState.store
    })
    const createRuleSetState = CreateRuleSetState.create({
        isModalUi:true,
        ruleTypeSelectState:ruleTypeSelectState,
        rootNode: rootNode
    })
    const ruleSetModalState = RuleSetModalState.create({
        ruleSetSelectState:ruleSetSelectState,
        createRuleSetState:createRuleSetState,
        isView: isView
    })
    return ruleSetModalState;
}